import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos',
)({
  component: () => <Outlet />,
})
